import React, { createContext, useState, useContext } from "react";

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
    const [toast, setToast] = useState({ show: false, message: "", type: "info" });

    const showToast = (message, type = "info", duration = 3000) => {
        setToast({ show: true, message, type });
        setTimeout(() => setToast({ show: false, message: "", type }), duration);
    };

    const Toast = () =>
        toast.show ? (
            <div
                style={{
                    position: "fixed",
                    top: "20px",
                    right: "20px",
                    padding: "15px 20px",
                    borderRadius: "4px",
                    color: "white",
                    backgroundColor: toast.type === "error" ? "#f44336" : "#4CAF50",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    zIndex: 2000,
                    animation: "slideIn 0.3s ease-out",
                }}
            >
                {toast.message}
            </div>
        ) : null;

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <Toast />
        </ToastContext.Provider>
    );
};